import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Product_Type } from '../../../models/product_Type';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { CustomerTypeService } from '../../../services/customer-type.service';
import { LocationService } from '../../../services/location.service';
import { PDAUserService } from '../../../services/pda-user.service';
import { ReportableService } from '../../../services/reportable.service';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { Customer_Type } from '../../../models/customer_Type';
import { RegionService } from '../../../services/region.service';
import { ProductTypeService } from '../../../services/product-type.service';
import { DeliveryNotesService } from '../../../services/delivery-notes.service';
import { PDAUser } from '../../../models/pda_User';
import { CheckUserType } from '../../../models/checkUserType';

@Component({
  selector: 'app-delivery-notes',
  templateUrl: './delivery-notes.component.html',
  styleUrls: ['./delivery-notes.component.css']
})
export class DeliveryNotesComponent implements OnInit {
  role = new CheckUserType();
  client;

  companyService: CompanyService;
  locationService: LocationService;

  customerTypes: Customer_Type[];
  users: PDAUser[];

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];

  productTypes: Product_Type[];

  filter: any = {
    customer_Type_Id: 0,
    company_Id: 0,
    location_Id: 0,
    pda_User_ID: 0,
    start_Date: moment().toDate(),
    end_Date: moment().toDate(),
    quick_Search: ''
  };

  

  page = new Page();
  rows = Array<any>();
  init: boolean;

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, pdaUserService: PDAUserService,
    public deliveryNotesService: DeliveryNotesService, public reportableService: ReportableService,
    customerTypeService: CustomerTypeService, regionService: RegionService, productTypeService: ProductTypeService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "Start_Time_Sorting";

    productTypeService.getAll().then((data) => {
      this.productTypes = data;
    });

    customerTypeService.getAll().then((data) => {
      this.customerTypes = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }
      
      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        /*if (this.role.isStandard) {
          this.locations = this.locationList.filter(c => {
            return c.company_Id == this.filter.company_Id;
          });
        }*/

      });

      this.loadTable(this.page);
    });

    this.companyService = companyService;
    this.locationService = locationService;

    pdaUserService.getAll().then((data) => {
      this.users = data;
      console.log("TEST Engineer");
      console.log(data);
    });
  }

  ngOnInit() {
    this.loadTable(this.page);
    this.init = true;
  }

  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);

    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  

  onSort(event) {
    if (event.column.prop == '' || event.column.prop == 'delivery_Note_ID') {
      return false;
    }

    const sortMapping = {
      'start_Time': 'Start_Time_Sorting',
    };

    this.page.sortOrder = event.newValue;
    this.page.sortBy = sortMapping[event.column.prop] || event.column.prop;
    console.log("sort by", this.page.sortBy);
    
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    console.log("Attempting to Load Table");
    console.log(this.filter);
    this.deliveryNotesService.getResults(this.page, this.filter.customer_Type_Id, this.filter.company_Id, this.filter.location_Id,
      this.filter.pda_User_ID, this.filter.start_Date, this.filter.end_Date, this.role.isStandard, this.filter.quick_Search).then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
        console.log(pagedData);
        console.log(this.page);
        console.log(this.rows);

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  downloadReport(id: number) {
    console.log("Downloading Report | ID: " + id);
    this.reportableService.getDeliveryNotes(id).then((data) => {
      importedSaveAs(data, 'Delivery Notes.pdf'); 
    });
  }

/*  downloadTermsAndConditions() {
    this.reportableService.getTermsAndConditions().then((data) => {
      importedSaveAs(data, 'MGS Terms and Conditions.pdf');
    });
  }*/

  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}
